<template>
  <v-container fluid>
    <v-row>
      <v-col cols="6" class="text-h6 font-weight-bold">ভাষাগত দক্ষতার তালিকা</v-col>
      <v-col cols="6" class="text-end">
        <v-btn color="secondary" size="small" class="me-3 rounded-lg" @click="openModal">
          <v-icon start>mdi-plus-circle-outline</v-icon> যোগ করুন
        </v-btn>
      </v-col>
      <v-col cols="12" md="12">
        <v-table class="language-table">
          <thead>
          <tr>
            <th>ভাষা</th>
            <th>শ্রবণ</th>
            <th>লিখন</th>
            <th>বাচন</th>
            <th>পঠন</th>
            <th>অন্যান্য পরীক্ষা</th>
            <th width="120">অ্যাকশন</th>
          </tr>
          </thead>

          <tbody>
          <tr v-if="languageData.length === 0">
            <td colspan="7" class="text-center py-6">
              কোন তথ্য পাওয়া যায়নি
            </td>
          </tr>
          <tr v-for="(item, index) in languageData" :key="index">
            <td>{{ item.language }}</td>
            <td>{{ item.listening }}</td>
            <td>{{ item.writing }}</td>
            <td>{{ item.speaking }}</td>
            <td>{{ item.reading }}</td>
            <td>{{ item.exam_participation }}</td>
            <td>
              <div class="d-flex align-center">
                <v-btn icon size="small" color="primary" variant="text" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon size="small" color="red" variant="text" @click="removeLanguage(index)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>

              </div>
            </td>
          </tr>
          </tbody>
        </v-table>
      </v-col>
    </v-row>


    <form>
    <InsertModal ref="Modal" title="ভাষাগত দক্ষতার তালিকা" :width="900">
        <template #modalBody>
          <v-row>
            <!-- ভাষার নাম -->
            <v-col cols="12" md="6">
              <v-select v-model="form.language" :items="languages" label="ভাষার নাম *" placeholder="ভাষার নাম বাছাই করুন" variant="outlined" density="comfortable" rounded="lg"></v-select>
            </v-col>
            <v-col cols="12" md="12"></v-col>
            <!-- শ্রবণ দক্ষতা -->
            <v-col cols="12" md="6">
              <div class="skill-section">
                <h4 class="section-title">
                  শ্রবণ দক্ষতা <span class="text-danger">*</span>
                </h4>
                <v-radio-group v-model="form.listening" inline hide-details class="custom-radio-group">
                  <v-radio label="চলতিমান" value="excellent"></v-radio>
                  <v-radio label="অনর্গল" value="fluent"></v-radio>
                  <v-radio label="চমৎকার" value="good"></v-radio>
                  <v-radio label="অসাধারণ" value="best"></v-radio>
                </v-radio-group>
              </div>
            </v-col>

            <!-- লিখন দক্ষতা -->
            <v-col cols="12" md="6">
              <div class="skill-section">
                <h4 class="section-title">
                  লিখন দক্ষতা <span class="text-danger">*</span>
                </h4>

                <v-radio-group v-model="form.writing" inline hide-details class="custom-radio-group">
                  <v-radio label="চলতিমান" value="excellent"></v-radio>
                  <v-radio label="অনর্গল" value="fluent"></v-radio>
                  <v-radio label="চমৎকার" value="good"></v-radio>
                  <v-radio label="অসাধারণ" value="best"></v-radio>
                </v-radio-group>
              </div>
            </v-col>

            <!-- বাচন দক্ষতা -->
            <v-col cols="12" md="6">
              <div class="skill-section">
                <h4 class="section-title">
                  বাচন দক্ষতা <span class="text-danger">*</span>
                </h4>

                <v-radio-group v-model="form.speaking" inline hide-details class="custom-radio-group">
                  <v-radio label="চলতিমান" value="excellent"></v-radio>
                  <v-radio label="অনর্গল" value="fluent"></v-radio>
                  <v-radio label="চমৎকার" value="good"></v-radio>
                  <v-radio label="অসাধারণ" value="best"></v-radio>
                </v-radio-group>
              </div>
            </v-col>

            <!-- পঠন দক্ষতা -->
            <v-col cols="12" md="6">
              <div class="skill-section">
                <h4 class="section-title">
                  পঠন দক্ষতা <span class="text-danger">*</span>
                </h4>
                <v-radio-group v-model="form.reading" inline hide-details class="custom-radio-group">
                  <v-radio label="চলতিমান" value="excellent"></v-radio>
                  <v-radio label="অনর্গল" value="fluent"></v-radio>
                  <v-radio label="চমৎকার" value="good"></v-radio>
                  <v-radio label="অসাধারণ" value="best"></v-radio>
                </v-radio-group>
              </div>
            </v-col>

            <!-- পরীক্ষা -->
            <v-col cols="12" md="6">
              <div class="skill-section mt-5">
                <h4 class="section-title">
                  অন্যান্য পরীক্ষায় অংশগ্রহণ করেছেন কি না?
                </h4>

                <v-radio-group v-model="form.exam_participation" inline hide-details class="custom-radio-group">
                  <v-radio label="হ্যাঁ" value="yes"></v-radio>
                  <v-radio label="না" value="no"></v-radio>
                </v-radio-group>
              </div>
            </v-col>
          </v-row>
        </template>
        <template #modalFooter>
          <v-row>
            <v-col cols="12">
              <v-btn color="primary" size="large" class="me-3 rounded-lg" type="submit">
                <v-icon start>mdi-content-save-outline</v-icon>সংরক্ষণ করুন
              </v-btn>
              <v-btn color="grey-darken-1" variant="outlined" size="large" class="rounded-lg" @click="resetForm">
                <v-icon start>mdi-refresh</v-icon>রিসেট
              </v-btn>

            </v-col>
          </v-row>
        </template>
    </InsertModal>
    </form>
  </v-container>
</template>

<script>
import InsertModal from "@/components/shared/InsertModal.vue";

export default {
  name: "LanguageComponent",
  components: {InsertModal},
  data() {
    return {
      form: {
        language: null,
        listening: "",
        writing: "",
        speaking: "",
        reading: "",
        exam_participation: "",
      },
      languages: [
        "বাংলা",
        "ইংরেজি",
        "আরবি",
        "হিন্দি",
      ],
      languageData: [
        {
          language: "বাংলা",
          listening: "অসাধারণ",
          writing: "অসাধারণ",
          speaking: "অসাধারণ",
          reading: "অসাধারণ",
          exam_participation: "না",
        },
        {
          language: "ইংরেজি",
          listening: "চমৎকার",
          writing: "ভালো",
          speaking: "ভালো",
          reading: "চমৎকার",
          exam_participation: "হ্যাঁ",
        },
      ],
    }
  },
  mounted() {},
  methods: {
    openModal() {
      this.$refs.Modal.openModal()
    },
    editItem(item) {
      console.log("Edit:", item);
    },

    removeLanguage(index) {
      this.languageData.splice(index, 1);
    },

    submitForm() {
      console.log(this.form);
    },

    resetForm() {
      this.form = {
        language: null,
        listening: "",
        writing: "",
        speaking: "",
        reading: "",
        exam_participation: "",
      };
    },
  },
};
</script>

<style scoped>
.language-table th {
  font-weight: 700 !important;
  font-size: 15px;
  white-space: nowrap;
}

.language-table td {
  font-size: 14px;
}


.section-title {
  font-size: 17px;
  font-weight: 700;
  margin-bottom: 18px;
}

.skill-section {
  padding-top: 10px;
}


.custom-radio-group :deep(.v-selection-control) {
  margin-right: 34px;
}
</style>